module.exports = [
  {
    value: 2,
    label: 'Женский'
  },
  {
    value: 1,
    label: 'Мужской'
  },
  {
    value: 3,
    label: 'Нет данных'
  }
]
